import { action, payload } from 'ts-action'
import { IGigDay } from 'models/GigDay'
import { IError, IPayload } from 'models/Global'

export const GigDaysFetching = action('GigDaysFetching', payload<boolean>())

export const GetGigDays = action('GetGigDays', payload<IPayload<IGigDay[]>>())

export const GetGigDaysErrors = action('GetGigDaysErrors', payload<IError>())
